import { Injectable } from '@angular/core';
import { ApiServiceBase } from './api.service.base';

export interface LibraryItem {
  name: string;
  description: string;
  sourceOrganizationId: string;
  sourceOrganizationName: string;
  compositeKey: string;
}

export interface CloneLibraryItemsResponseItem {
  compositeKey: string;
  reportId: string;
}

export interface CloneLibraryItemsResponse {
  created: CloneLibraryItemsResponseItem[];
}

@Injectable({
  providedIn: 'root'
})
export class LibraryService {
  private reportLibraryItemCollections: { [cacheKey: string]: LibraryItem[] } = {};

  constructor(private apiService: ApiServiceBase) {}

  public getCachedLibraryItems(cacheKey: string): LibraryItem[] {
    return this.reportLibraryItemCollections[cacheKey] ?? [];
  }

  public async getLibraryItems(apiUrl: string, cacheKey: string): Promise<LibraryItem[]> {
    const rawItems = await this.apiService.Get<any[]>(apiUrl);

    // Normalize to camelCase so callers don't care whether the API sent PascalCase or camelCase.
    const items: LibraryItem[] = (rawItems ?? []).map((r: any) => {
      const name = (r?.name ?? r?.Name ?? '').toString();
      const description = (r?.description ?? r?.Description ?? '').toString();
      const sourceOrganizationId = (r?.sourceOrganizationId ?? r?.SourceOrganizationId ?? '').toString();
      const sourceOrganizationName = (r?.sourceOrganizationName ?? r?.SourceOrganizationName ?? '').toString();
      const compositeKey = (r?.compositeKey ?? r?.CompositeKey ?? '').toString();

      return {
        name,
        description,
        sourceOrganizationId,
        sourceOrganizationName,
        compositeKey
      } as LibraryItem;
    });

    this.reportLibraryItemCollections[cacheKey] = items;
    return items;
  }

  public cloneFromLibrary(postUrl: string, compositeKeys: string[]): Promise<CloneLibraryItemsResponse> {
    return this.apiService.Post<CloneLibraryItemsResponse>(postUrl, {
      compositeKeys: compositeKeys ?? []
    });
  }
}


